import Vue from 'vue'
import { MLInstaller, MLCreate, MLanguage } from './'
// import { MLInstaller, MLCreate, MLanguage } from 'vue-multilanguage'

Vue.use(MLInstaller)

export default new MLCreate({
  initial: '1', // EN
  save: process.env.NODE_ENV === 'development',
  languages: [
    // EN
    new MLanguage('1').create({
      'You do not have permission to open this page': 'You do not have permission to open this page',
      'If you think you should, ask an administrator to check your role': 'If you think you should, ask an administrator to check your role',
      'Back to dashboard': 'Back to dashboard',
      'No access': 'No access',
      'You do not have permission for this action': 'You do not have permission for this action',
      'RECORD_NOT_EDITABLE': 'Record is closed or deleted',
      'This record was closed while you were editing it': 'This record was closed while you were editing it',
      'This record was deleted while you were editing it': 'This record was deleted while you were editing it',
      'Your changes were not saved. See the History tab for who changed it.': 'Your changes were not saved. See the History tab for who changed it.',
      'Version': 'Version',
      'Sign In': 'Sign In',
      'All rights reserved': 'All rights reserved',
      'Copyright': 'Copyright',
      'Logged': 'Logged',
      'Comments': 'Comments',
      'Whs': 'Whs',
      'Owner': 'Owner',
      'FirmId': 'FirmId',
      'POSID': 'POSID',
      'Pr Code': 'Pr. Code',
      'Product': 'Product',
      'Supp': 'Supp.',
      'Reason': 'Reason',
      'Fault': 'Fault',
      'Client': 'Client',
      'Deliv Date': 'Deliv. Date',
      'Picked': 'Picked',
      'Ordered': 'Ordered',
      'Diff Qty': 'Diff. Qty.',
      'Pck list': 'Pck. list',
      'Approved': 'Approved',
      'Client Address': 'Client Address',
      'Public Canceled Lines': 'Public Canceled Lines',
      'Comment': 'Comment',
      'Order No': 'Order No',
      'Document No': 'Document No',
      'Manager': 'Manager',
      'Activity': 'Activity',
      'EAN': 'EAN',
      'Diff %': 'Diff %',
      'Agent': 'Agent',
      'Tvnt': 'Tvnt',
      'Agent Email': 'Agent Email',
      'Supp Pr Code': 'Supp Pr Code',
      'Logged at': 'Logged at',
      'Yes': 'Yes',
      'No': 'No',
      'Report': 'Report',
      'Public Problems': 'Public Problems',
      'Public Problems list': 'Public Problems list',
      'Countries': 'Countries',
      'Serial No': 'Serial No',
      'Created At': 'Created At',
      'Customer': 'Customer',
      'Address': 'Address',
      'Product code': 'Code',
      'Product Name': 'Product Name',
      'Quantity': 'Quantity',
      'Problem': 'Problem',
      'Decision': 'Decision',
      'To Department': 'To Department',
      'Sale Group': 'Sale Group',
      'Source': 'Source',
      'Is confirmed': 'Is confirmed',
      'Public Delays': 'Public Delays',
      'Public Returns': 'Public Returns',
      'Problem No': 'Problem No',
      'Collection Date': 'Collection Date',
      'Return Type': 'Return Type',
      'Row Status Type': 'Row Status Type'
    }),
    // LT
    new MLanguage('2').create({
      'You do not have permission to open this page': 'Neturite teisių atidaryti šio puslapio',
      'If you think you should, ask an administrator to check your role': 'Jei manote, kad turėtumėte, paprašykite administratoriaus patikrinti jūsų rolę',
      'Back to dashboard': 'Grįžti į pradžią',
      'No access': 'Nėra prieigos',
      'You do not have permission for this action': 'Neturite teisių šiam veiksmui',
      'RECORD_NOT_EDITABLE': 'Įrašas yra uždarytas arba ištrintas',
      'This record was closed while you were editing it': 'Šis įrašas buvo uždarytas, kol jį redagavote',
      'This record was deleted while you were editing it': 'Šis įrašas buvo ištrintas, kol jį redagavote',
      'Your changes were not saved. See the History tab for who changed it.': 'Jūsų pakeitimai neišsaugoti. Kas pakeitė, žiūrėkite istorijos skiltyje.',
      'Version': 'Versija',
      'Sign In': 'Prisijungti',
      'All rights reserved': 'Visos teisės saugomos',
      'Copyright': 'Autorinės teisės',
      'Public Canceled Lines': 'Vieši išbraukymai',
      'Logged': 'Pažymėta',
      'Deliv Date': 'Prist. data',
      'Whs': 'Sand.',
      'Owner': 'Savininkas',
      'FirmId': 'FirmId',
      'POSID': 'POSID',
      'Client': 'Klientas',
      'Client Address': 'Kliento adresas',
      'Pr Code': 'Pr. kodas',
      'Product': 'Prekė',
      'Supp': 'Tiek.',
      'Picked': 'Priimta',
      'Ordered': 'Užsakyta',
      'Diff Qty': 'Skirtumas',
      'Pck list': 'Pck. sąraš.',
      'Reason': 'Priežastis',
      'Fault': 'Klaida',
      'Comments': 'Komentarai',
      'Approved': 'Patvirtinta',
      'Comment': 'Komentaras',
      'Order No': 'Užsakymo Nr.',
      'Document No': 'Dokumento Nr.',
      'Manager': 'Vadybininkas',
      'Activity': 'Veikla',
      'EAN': 'EAN',
      'Diff %': 'Skirt %',
      'Agent': 'Agentas',
      'Tvnt': 'Tvnt',
      'Agent Email': 'Agento e-paštas',
      'Supp Pr Code': 'Tiek Pr Kodas',
      'Logged at': 'Įrašyta',
      'Yes': 'Taip',
      'No': 'Ne',
      'Report': 'Ataskaitos',
      'Public Problems': 'Viešos problemos',
      'Public Problems list': 'Viešų problemų sąrašas',
      'Countries': 'Šalys',
      'Serial No': 'Serijos nr.',
      'Created At': 'Sukurta',
      'Customer': 'Klientas',
      'Address': 'Adresas',
      'Product code': 'Kodas',
      'Product Name': 'Produkto pavadinimas',
      'Quantity': 'Kiekis',
      'Problem': 'Problema',
      'Decision': 'Sprendimas',
      'To Department': 'Departamentui',
      'Sale Group': 'Veikla',
      'Source': 'Šaltinis',
      'Is confirmed': 'Ar patvirtinta',
      'Public Delays': 'Vieši vėlavimai',
      'Public Returns': 'Vieši grąžinimai',
      'Problem No': 'Problemos Nr',
      'Collection Date': 'Paėmimo data',
      'Return Type': 'Grąžinimo tipas',
      'Row Status Type': 'Eilutės statusas'
    }),
    // LV
    new MLanguage('3').create({
      'You do not have permission to open this page': 'Jums nav tiesību atvērt šo lapu',
      'If you think you should, ask an administrator to check your role': 'Ja domājat, ka jums vajadzētu, lūdziet administratoram pārbaudīt jūsu lomu',
      'Back to dashboard': 'Atgriezties uz sākumu',
      'No access': 'Nav piekļuves',
      'You do not have permission for this action': 'Jums nav tiesību veikt šo darbību',
      'RECORD_NOT_EDITABLE': 'Ieraksts ir slēgts vai dzēsts',
      'This record was closed while you were editing it': 'Šis ieraksts tika slēgts, kamēr jūs to rediģējāt',
      'This record was deleted while you were editing it': 'Šis ieraksts tika dzēsts, kamēr jūs to rediģējāt',
      'Your changes were not saved. See the History tab for who changed it.': 'Jūsu izmaiņas netika saglabātas. Skatiet vēstures cilni, lai redzētu, kas to mainīja.',
      'Version': 'Versija',
      'Sign In': 'Lelogoties',
      'All rights reserved': 'Visas tiesības aizsargātas',
      'Copyright': 'Autortiesības',
      'Logged': 'Logged',
      'Comments': 'Comments',
      'Whs': 'Whs',
      'Owner': 'Owner',
      'FirmId': 'FirmId',
      'POSID': 'POSID',
      'Pr Code': 'Pr Code',
      'Product': 'Product',
      'Supp': 'Supp',
      'Reason': 'Reason',
      'Fault': 'Fault',
      'Client': 'Client',
      'Deliv Date': 'Deliv Date',
      'Picked': 'Picked',
      'Ordered': 'Ordered',
      'Diff Qty': 'Diff Qty',
      'Pck list': 'Pck list',
      'Approved': 'Approved',
      'Client Address': 'Client Address',
      'Public Canceled Lines': 'Public Canceled Lines',
      'Comment': 'Comment',
      'Order No': 'Order No',
      'Document No': 'Document No',
      'Manager': 'Manager',
      'Activity': 'Activity',
      'EAN': 'EAN',
      'Diff %': 'Diff %',
      'Agent': 'Agent',
      'Tvnt': 'Tvnt',
      'Agent Email': 'Agent Email',
      'Supp Pr Code': 'Supp Pr Code',
      'Logged at': 'Logged at',
      'Yes': 'Yes',
      'No': 'No',
      'Report': 'Report',
      'Public Problems': 'Public Problems',
      'Public Problems list': 'Public Problems list',
      'Countries': 'Valstis',
      'Serial No': 'Sērijas numurs',
      'Created At': 'Izveidots',
      'Customer': 'Klients',
      'Address': 'Adrese',
      'Product code': 'Kods',
      'Product Name': 'Product Name',
      'Quantity': 'Quantity',
      'Problem': 'Problēma',
      'Decision': 'Decision',
      'To Department': 'Nodaļai',
      'Sale Group': 'Pārdošanas grupa',
      'Source': 'Avots',
      'Is confirmed': 'Is confirmed',
      'Public Delays': 'Public Delays',
      'Public Returns': 'Public Returns'
    }),
    // EE
    new MLanguage('4').create({
      'You do not have permission to open this page': 'Teil pole õigust seda lehte avada',
      'If you think you should, ask an administrator to check your role': 'Kui arvate, et peaksite, paluge administraatoril teie roll üle vaadata',
      'Back to dashboard': 'Tagasi töölauale',
      'No access': 'Juurdepääs puudub',
      'You do not have permission for this action': 'Teil pole õigust selleks toiminguks',
      'RECORD_NOT_EDITABLE': 'Kirje on suletud või kustutatud',
      'This record was closed while you were editing it': 'See kirje suleti, kui te seda muutsite',
      'This record was deleted while you were editing it': 'See kirje kustutati, kui te seda muutsite',
      'Your changes were not saved. See the History tab for who changed it.': 'Teie muudatusi ei salvestatud. Vaadake ajaloo vahekaarti, et näha, kes seda muutis.',
      'Version': 'Versioon',
      'Sign In': 'Logi sisse',
      'All rights reserved': 'Kõik õigused kaitstud',
      'Copyright': 'Autoriõigus',
      'Logged': 'Logged',
      'Comments': 'Comments',
      'Whs': 'Whs',
      'Owner': 'Owner',
      'FirmId': 'FirmId',
      'POSID': 'POSID',
      'Pr Code': 'Pr Code',
      'Product': 'Product',
      'Supp': 'Supp',
      'Reason': 'Reason',
      'Fault': 'Fault',
      'Client': 'Client',
      'Deliv Date': 'Deliv Date',
      'Picked': 'Picked',
      'Ordered': 'Ordered',
      'Diff Qty': 'Diff Qty',
      'Pck list': 'Pck list',
      'Approved': 'Approved',
      'Client Address': 'Client Address',
      'Public Canceled Lines': 'Public Canceled Lines',
      'Comment': 'Comment',
      'Order No': 'Order No',
      'Document No': 'Document No',
      'Manager': 'Manager',
      'Activity': 'Activity',
      'EAN': 'EAN',
      'Diff %': 'Diff %',
      'Agent': 'Agent',
      'Tvnt': 'Tvnt',
      'Agent Email': 'Agent Email',
      'Supp Pr Code': 'Supp Pr Code',
      'Logged at': 'Logged at',
      'Yes': 'Yes',
      'No': 'No',
      'Report': 'Report',
      'Public Problems': 'Public Problems',
      'Public Problems list': 'Public Problems list',
      'Countries': 'Countries',
      'Serial No': 'Serial No',
      'Created At': 'Created At',
      'Customer': 'Customer',
      'Address': 'Address',
      'Product code': 'Code',
      'Product Name': 'Product Name',
      'Quantity': 'Quantity',
      'Problem': 'Problem',
      'Decision': 'Decision',
      'To Department': 'To Department',
      'Sale Group': 'Sale Group',
      'Source': 'Source',
      'Is confirmed': 'Is confirmed',
      'Public Delays': 'Public Delays',
      'Public Returns': 'Public Returns'
    }),
    // RU
    new MLanguage('5').create({
      'You do not have permission to open this page': 'У вас нет прав на открытие этой страницы',
      'If you think you should, ask an administrator to check your role': 'Если считаете, что доступ нужен, попросите администратора проверить вашу роль',
      'Back to dashboard': 'Вернуться на главную',
      'No access': 'Нет доступа',
      'You do not have permission for this action': 'У вас нет прав на это действие',
      'RECORD_NOT_EDITABLE': 'Запись закрыта или удалена',
      'This record was closed while you were editing it': 'Эта запись была закрыта, пока вы её редактировали',
      'This record was deleted while you were editing it': 'Эта запись была удалена, пока вы её редактировали',
      'Your changes were not saved. See the History tab for who changed it.': 'Ваши изменения не сохранены. Кто изменил — смотрите во вкладке истории.',
      'Version': 'Версия',
      'Sign In': 'Войти в систему',
      'All rights reserved': 'Все права защищены',
      'Copyright': 'Авторские права',
      'Logged': 'Logged',
      'Comments': 'Comments',
      'Whs': 'Whs',
      'Owner': 'Owner',
      'FirmId': 'FirmId',
      'POSID': 'POSID',
      'Pr Code': 'Pr Code',
      'Product': 'Product',
      'Supp': 'Supp',
      'Reason': 'Reason',
      'Fault': 'Fault',
      'Client': 'Client',
      'Deliv Date': 'Deliv Date',
      'Picked': 'Picked',
      'Ordered': 'Ordered',
      'Diff Qty': 'Diff Qty',
      'Pck list': 'Pck list',
      'Approved': 'Approved',
      'Client Address': 'Client Address',
      'Public Canceled Lines': 'Public Canceled Lines',
      'Comment': 'Comment',
      'Order No': 'Order No',
      'Document No': 'Document No',
      'Manager': 'Manager',
      'Activity': 'Activity',
      'EAN': 'EAN',
      'Diff %': 'Diff %',
      'Agent': 'Agent',
      'Tvnt': 'Tvnt',
      'Agent Email': 'Agent Email',
      'Supp Pr Code': 'Supp Pr Code',
      'Logged at': 'Logged at',
      'Yes': 'Да',
      'No': 'Нет',
      'Report': 'Report',
      'Public Problems': 'Public Problems',
      'Public Problems list': 'Public Problems list',
      'Countries': 'Страны',
      'Serial No': 'Серийный номер',
      'Created At': 'Создано в',
      'Customer': 'Клиент',
      'Address': 'Адрес',
      'Product code': 'Код',
      'Product Name': 'Продукт',
      'Quantity': 'Количество',
      'Problem': 'Проблема',
      'Decision': 'Decision',
      'To Department': 'В департамент(отдел)',
      'Sale Group': 'Группа продажи',
      'Source': 'Источник',
      'Is confirmed': 'Подтверждено',
      'Public Delays': 'Public Delays',
      'Public Returns': 'Public Returns'
    })
  ],
  middleware: (component, path) => {
    return path
  }
})
